import { render, staticRenderFns } from "./Toc.vue?vue&type=template&id=b21ba73c&"
import script from "./Toc.vue?vue&type=script&lang=js&"
export * from "./Toc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports